import type { JobStatus, LeadStatus } from '@conversia/shared-types';
import type { Paginated } from '@/lib/types';
import { api } from './client';

/**
 * Cartera de clientes (centro del negocio). Prefijo: /api/clientes (ADMIN).
 * Tipos espejo de apps/api/src/services/clientes.service.ts.
 */

export type SurveySentiment = 'good' | 'bad' | 'neutral';

export interface CompraResumen {
  modelo: string | null;
  precio: number | null;
  fecha: string | null;
}

/** Ficha de Osito del cliente: lo que sabe un negocio que no instala nada. */
export interface ClienteOsitoResumen {
  producto: string | null;
  /** La talla que DIJO. No se valida ni se equivale. */
  talla: string | null;
  tipoCliente: string;
  modalidad: string;
  sucursalId: string | null;
  /** Vendedor dueno del cliente: el que lo atendio primero. */
  vendedor: string | null;
  intentos: number;
  descartadoAt: string | null;
}

export interface ClienteRow {
  id: string;
  nombre: string;
  telefono: string | null;
  zona: string | null;
  ultimaCompra: CompraResumen | null;
  comprasCount: number;
  totalHistorico: number;
  tecnico: string | null;
  estadoUltimoTrabajo: JobStatus | null;
  encuesta: SurveySentiment | null;
  conversationId: string | null;
  osito: ClienteOsitoResumen | null;
}

export interface ClienteTrabajo {
  id: string;
  descripcion: string;
  estado: JobStatus;
  esGarantia: boolean;
  fecha: string | null;
  completedAt: string | null;
  modelo: string | null;
  precio: number | null;
  tecnico: string | null;
  resultado: string | null;
  /** Motivo del técnico cuando NO se completó. */
  motivo: string | null;
  /** Registro que el técnico anota al cerrar (código/serie, inconvenientes). */
  registroArticulo: string | null;
  encuesta: SurveySentiment | null;
  surveyResponse: string | null;
}

export interface ClienteFicha {
  id: string;
  nombre: string;
  telefono: string | null;
  zona: string | null;
  avatarUrl: string | null;
  leadStatus: LeadStatus | null;
  leadCard: Record<string, unknown>;
  conversationId: string | null;
  comprasCount: number;
  totalHistorico: number;
  trabajos: ClienteTrabajo[];
  osito: ClienteOsitoResumen | null;
}

export interface ListClientesParams {
  search?: string;
  compro?: 'si' | 'no';
  zona?: string;
  esteMes?: 'true' | 'false';
  skip?: number;
  take?: number;
}

export const listClientes = (params: ListClientesParams = {}) =>
  api.get<Paginated<ClienteRow>>('/api/clientes', { query: params });

export const getClienteFicha = (id: string) => api.get<ClienteFicha>(`/api/clientes/${id}`);

/** Borra el historial y la ficha del cliente: la asistente lo atiende como la primera vez. */
export const reiniciarConversacion = (id: string) =>
  api.post<{ conversaciones: number }>(`/api/clientes/${id}/reiniciar`);
